import { useTranslation } from 'react-i18next';

export default function ServicesList() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-flashlight-line',
      title: t('servicesPage.service1Title'),
      description: t('servicesPage.service1Desc'),
      features: [
        t('servicesPage.service1Feature1'),
        t('servicesPage.service1Feature2'),
        t('servicesPage.service1Feature3'),
        t('servicesPage.service1Feature4'),
      ],
      gradient: 'from-[#FF6B6B] to-[#FF8E53]',
      image:
        'https://public.readdy.ai/ai/img_res/24fb1c4f797ce9dbcfce27751d836886.jpg',
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('servicesPage.service2Title'),
      description: t('servicesPage.service2Desc'),
      features: [
        t('servicesPage.service2Feature1'),
        t('servicesPage.service2Feature2'),
        t('servicesPage.service2Feature3'),
        t('servicesPage.service2Feature4'),
      ],
      gradient: 'from-[#4ECDC4] to-[#44A08D]',
      image:
        'https://readdy.ai/api/search-image?query=Modern%20airport%20baggage%20claim%20management%20center%20with%20professional%20staff%20reviewing%20damage%20reports%20on%20digital%20tablets%2C%20organized%20workspace%20with%20damaged%20luggage%20assessment%20area%2C%20bright%20professional%20lighting%2C%20clean%20contemporary%20office%20environment%20with%20teal%20and%20orange%20accent%20colors%2C%20high-tech%20monitoring%20screens%20in%20background&width=600&height=400&seq=service-claims-001&orientation=landscape',
    },
    {
      icon: 'ri-calendar-check-line',
      title: t('servicesPage.service3Title'),
      description: t('servicesPage.service3Desc'),
      features: [
        t('servicesPage.service3Feature1'),
        t('servicesPage.service3Feature2'),
        t('servicesPage.service3Feature3'),
        t('servicesPage.service3Feature4'),
      ],
      gradient: 'from-[#C9A961] to-[#B8935A]',
      image:
        'https://readdy.ai/api/search-image?query=Airport%20baggage%20handling%20equipment%20maintenance%20inspection%2C%20professional%20technician%20checking%20conveyor%20belt%20system%20with%20clipboard%20and%20tools%2C%20modern%20airport%20terminal%20background%2C%20bright%20industrial%20lighting%2C%20clean%20organized%20workspace%20with%20safety%20equipment%2C%20contemporary%20professional%20photography%20with%20warm%20and%20cool%20tones&width=600&height=400&seq=service-maintenance-001&orientation=landscape',
    },
    {
      icon: 'ri-truck-line',
      title: t('servicesPage.service4Title'),
      description: t('servicesPage.service4Desc'),
      features: [
        t('servicesPage.service4Feature1'),
        t('servicesPage.service4Feature2'),
        t('servicesPage.service4Feature3'),
        t('servicesPage.service4Feature4'),
      ],
      gradient: 'from-[#FF8E53] to-[#FFB347]',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20delivery%20van%20with%20premium%20luggage%20being%20carefully%20loaded%20by%20uniformed%20staff%2C%20modern%20logistics%20vehicle%20with%20company%20branding%2C%20airport%20terminal%20in%20background%2C%20golden%20hour%20lighting%2C%20clean%20professional%20service%20aesthetic%20with%20orange%20and%20teal%20color%20accents%2C%20high%20quality%20commercial%20photography&width=600&height=400&seq=service-logistics-001&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: t('servicesPage.service5Title'),
      description: t('servicesPage.service5Desc'),
      features: [
        t('servicesPage.service5Feature1'),
        t('servicesPage.service5Feature2'),
        t('servicesPage.service5Feature3'),
        t('servicesPage.service5Feature4'),
      ],
      gradient: 'from-[#44A08D] to-[#4ECDC4]',
      image:
        'https://readdy.ai/api/search-image?query=Modern%20professional%20luggage%20repair%20workshop%20interior%20with%20multiple%20workstations%2C%20organized%20tool%20storage%2C%20bright%20LED%20lighting%2C%20clean%20industrial%20design%2C%20technicians%20working%20on%20various%20suitcases%2C%20contemporary%20workspace%20with%20teal%20and%20orange%20accent%20lighting%2C%20high-tech%20equipment%20and%20organized%20parts%20inventory&width=600&height=400&seq=service-workshop-001&orientation=landscape',
    },
    {
      icon: 'ri-settings-3-line',
      title: t('servicesPage.service6Title'),
      description: t('servicesPage.service6Desc'),
      features: [
        t('servicesPage.service6Feature1'),
        t('servicesPage.service6Feature2'),
        t('servicesPage.service6Feature3'),
        t('servicesPage.service6Feature4'),
      ],
      gradient: 'from-[#FF6B6B] to-[#C9A961]',
      image:
        'https://readdy.ai/api/search-image?query=Business%20meeting%20with%20airport%20executives%20and%20service%20provider%20discussing%20custom%20solutions%2C%20modern%20conference%20room%20with%20digital%20presentation%20screens%20showing%20charts%20and%20graphs%2C%20professional%20corporate%20environment%2C%20warm%20ambient%20lighting%2C%20contemporary%20office%20design%20with%20teal%20and%20orange%20brand%20colors%2C%20collaborative%20atmosphere&width=600&height=400&seq=service-custom-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t('servicesPage.listTitle')}{' '}
            <span className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent">
              {t('servicesPage.listTitleHighlight')}
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            {t('servicesPage.listSubtitle')}
          </p>
        </div>

        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[400px] object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div
                    className={`absolute top-6 left-6 w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center shadow-xl`}
                  >
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h3
                  className="text-3xl font-bold text-gray-900 mb-4"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {service.title}
                </h3>
                <p className="text-gray-500 mb-6 leading-relaxed">{service.description}</p>

                <div className="space-y-3 mb-8">
                  {service.features.map((feature, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-gradient-to-br from-[#4ECDC4]/20 to-[#44A08D]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#4ECDC4] text-sm"></i>
                      </div>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>

                <a
                  href="/contact"
                  className="inline-flex items-center gap-2 text-[#FF6B6B] font-semibold hover:gap-3 transition-all cursor-pointer group"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {t('servicesPage.learnMore')}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
